<span *ngIf="address" class="address">
  <span *ngIf="streetAddress"> {{ streetAddress }} <br /> </span>
  <ng-container *ngIf="cityStatePostalCode"> {{ cityStatePostalCode }} <br /> </ng-container>
  <ng-container *ngIf="county || country">
    <span *ngIf="county">
      <span *ngIf="!country" title="County">{{ county }}</span>
      <span *ngIf="country" title="Country">{{ county }},</span>
    </span>
    <span *ngIf="country" title="Country">{{ country }}</span> <br />
  </ng-container>
  <span
    class="address_coordinates"
    *ngIf="address.coordinates?.latitude || address.coordinates?.longitude"
  >
    <mat-icon>place</mat-icon>{{ address.coordinates | coordinates }}
  </span>
  <div *ngIf="gpsId"><mat-icon>place</mat-icon>{{ gpsId }}</div>
</span>
